var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2001 91.9H86.8001C89.6051 91.9 91.9001 89.605 91.9001 86.8V5.19998C91.9001 2.39498 89.6051 0.0999756 86.8001 0.0999756H5.2001C2.3951 0.0999756 0.100098 2.39498 0.100098 5.19998V86.8C0.100098 89.605 2.3951 91.9 5.2001 91.9ZM15.4001 10.3C18.2051 10.3 20.5001 12.595 20.5001 15.4C20.5001 18.205 18.2051 20.5 15.4001 20.5C12.5951 20.5 10.3001 18.205 10.3001 15.4C10.3001 12.595 12.5951 10.3 15.4001 10.3ZM81.7001 10.3V20.5H25.6001V10.3H81.7001ZM15.4001 30.7C18.2051 30.7 20.5001 32.995 20.5001 35.8C20.5001 38.605 18.2051 40.9 15.4001 40.9C12.5951 40.9 10.3001 38.605 10.3001 35.8C10.3001 32.995 12.5951 30.7 15.4001 30.7ZM81.7001 30.7V40.9H25.6001V30.7H81.7001ZM15.4001 51.1C18.2051 51.1 20.5001 53.395 20.5001 56.2C20.5001 59.005 18.2051 61.3 15.4001 61.3C12.5951 61.3 10.3001 59.005 10.3001 56.2C10.3001 53.395 12.5951 51.1 15.4001 51.1ZM81.7001 51.1V61.3H25.6001V51.1H81.7001ZM15.4001 71.5C18.2051 71.5 20.5001 73.795 20.5001 76.6C20.5001 79.405 18.2051 81.7 15.4001 81.7C12.5951 81.7 10.3001 79.405 10.3001 76.6C10.3001 73.795 12.5951 71.5 15.4001 71.5ZM81.7001 71.5V81.7H25.6001V71.5H81.7001Z",
    fill: "#312A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/list-view.f343a1fd08891e9da92a92daca1909ec.svg";
export { ForwardRef as ReactComponent };